"use client"
import { iconsMap } from "@/public/icons/iconsMap"
import CommunityTexts from "@/ui/common/bit/CommunityTexts"
import { colors } from "@/ui/theme/colors"
import { mediaQueries } from "@/ui/theme/mediaQueries"
import { Box, css, styled } from "@mui/material"
import { useTranslations } from "next-intl"
import React from "react"
import { sendBlockEvent } from "utils/gtm"
import { getCompanyGrowthPercentage } from "../ContentWithSlidersBlock/service"
import InvestmentSimulator from "../InvestmentSimulator/InvestmentSimulator"
import { InvestSimulatorBlockProps } from "./types"

const StyledContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  position: relative;
  ${mediaQueries.desktopM} {
    flex-direction: row-reverse;
    gap: 80px;
  }
`
const StyledSimulatorWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "fullWidth",
})<{ fullWidth?: boolean }>`
  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `}

  ${mediaQueries.desktopM} {
    max-width: 1064px;
  }
`

const StyledComunityTitle = styled(Box)`
  text-align: start;
  color: ${colors.white};
  ${mediaQueries.mobile} {
    text-align: center;
  }
  span {
    background-color: ${colors.red};
    border-radius: 6px;
    margin-right: 10px;
    margin-left: 10px;
  }
`

// Using & to increase specificity and target the inner component directly
const StyledCommunityTexts = styled(CommunityTexts)`
  align-items: center;
  color: ${colors.white};

  & .title {
    color: ${colors.white};
  }

  & .subtitle {
    color: ${colors.white};
  }

  && .text {
    color: ${colors.white} !important;
  }

  ${mediaQueries.desktopM} {
    align-items: center;
  }
  ${mediaQueries.mobile} {
    margin-bottom: 40px;
  }
`

const InvestSimulatorBlock: React.FC<InvestSimulatorBlockProps> = (props) => {
  const ArrowIcon = iconsMap.left_red_arrow
  const {
    subtitle,
    text,
    button,
    investmentData,
    className,
    fullWidth,
    additionalButton,
    tooltipText,
  } = props
  const t = useTranslations("InvestSimulator.block")
  const fiveYearsTextWithPercentage = getCompanyGrowthPercentage(
    investmentData?.investmentData,
    "הכשרה",
  )
  // Only show mock data indicator if not in production
  const showErrorMessage =
    !investmentData?.isProduction && !investmentData?.isFetched

  // GTM event handler for the main CTA button
  // Use the actual button name if available, fallback to default
  // Use the actual button name if available, fallback to a hardcoded default
  const buttonName = button?.links?.[0]?.name || "כאלה תשואות אני רוצה"
  const handleAdditionalButtonClick = () => {
    sendBlockEvent({
      blockId: "4", // component_no: 4
      componentName: "לקוחות הכשרה best invest",
      title: `${t("textBefore")} ${fiveYearsTextWithPercentage}% ${t("textAfter")}`,
      actionName: undefined,
      buttonName,
    })
  }

  return (
    <StyledContainer className={className}>
      <StyledCommunityTexts
        data={{
          subtitle: subtitle,
          text: { richText: text || "" },
          button,
          additionalButton,
          ArrowIcon,
        }}
        onAdditionalButtonClick={handleAdditionalButtonClick}
      >
        <StyledComunityTitle>
          {t("textBefore")}
          <span>{fiveYearsTextWithPercentage}%</span>
          {t("textAfter")}
        </StyledComunityTitle>
      </StyledCommunityTexts>
      {investmentData?.investmentData && (
        <StyledSimulatorWrapper fullWidth={fullWidth}>
          <InvestmentSimulator
            apiData={investmentData.investmentData}
            isMockData={showErrorMessage}
            fullWidth={fullWidth}
            tooltipData={tooltipText}
          />
        </StyledSimulatorWrapper>
      )}
    </StyledContainer>
  )
}

export default InvestSimulatorBlock
